export default __webpack_public_path__ + "static/media/rossi.16d9d427.jpg";